import { atom } from 'recoil'

export type TagStatusProgress = string

export const currentStatusProgressState = atom<TagStatusProgress>({
  key: 'tagStatusProgress',
  default: '',
})
